export const postPickingTransfer = async (transfer) => {

    const requestPath = process.env.REACT_APP_APPSTATEMENT !== "development" ? process.env.REACT_APP_BASEURL_PRODUCTION : process.env.REACT_APP_BASEURL_DEVELOPING

    const resultPostPickingTransfer = await window.fetch(`${requestPath}/back/routes/order.php`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ transfer })
    })

    const { result, message, error_msg } = await resultPostPickingTransfer.json()
    return { result, message, error_msg }
}
